











































































































































import { ActionType, DisabledUser, Routes, SuccessMessage, ValidationMessages } from '@/constants';
import { getCurrentSession, updatePassword } from '@/core';
import { checkRequireField, validatePassword } from '@/util';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { sendPasswordUpdateMail } from '../services/service';
import EyeIcon from '@/assets/icons/EyeIcon.vue';
import EyeHideIcon from '@/assets/icons/EyeHideIcon.vue';

export default Vue.extend({
  name: 'ChangePassword',
  components: {
    OnSuccess: () => import('@/components/modals/SuccessMessage.vue'),
    EyeHideIcon,
    EyeIcon
  },
  data () {
    return {
      passwordChanged: SuccessMessage.passwordChanged,
      updateSuccessful: false,
      passwordEye: {
        currentPassword: false,
        newPassword: false,
        confirmPassword: false
      },
      password: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      requiredPassword: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordErrors: [] as string[]
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedInAsAdmin',
      'user'
    ])
  },
  methods: {
    handleSessionError () {
      this.$store.dispatch(ActionType.UPDATE_SIGNIN_STATUS, false);
      this.$router.push({ name: Routes.SIGNIN, query: { redirect: this.$router.currentRoute.path } });
    },
    onSubmit () {
      if (!this.isLoggedInAsAdmin) {
        this.handlePasswordChange();
      } else {
        this.$emit('showViewVersion');
      }
    },
    async handlePasswordChange () {
      try {
        await getCurrentSession();
        if (this.validatepassword()) {
          updatePassword(this.password.currentPassword, this.password.newPassword).then((response) => {
            this.onPasswordUpdate();
          }).catch((error) => {
            this.onPasswordError(error)
          })
        }
      } catch (error) {
        this.handleSessionError();
      }
    },
    onPasswordUpdate () {
      this.updateSuccessful = true;
      sendPasswordUpdateMail();
    },
    onPasswordError (error: any) {
      if (error.message.includes('Incorrect username or password')) {
        this.passwordErrors.push(ValidationMessages.incorrectOldPassword);
      } else if (error.message.toLowerCase().includes(DisabledUser().message.toLowerCase())) {
        this.passwordErrors.push(error.message)
        this.handleSessionError()
      } else {
        this.passwordErrors.push(error.message)
      }
    },
    checkRequiredPassword () {
      this.requiredPassword.currentPassword = checkRequireField(this.password.currentPassword, 'Old Password');
      this.requiredPassword.newPassword = checkRequireField(this.password.newPassword, 'New Password');
      this.requiredPassword.confirmPassword = checkRequireField(this.password.confirmPassword, 'Confirm New Password');
    },
    validatepassword () {
      this.passwordErrors = [];
      const requiredFields = Object.values(this.password).every(x => !!x);
      this.checkRequiredPassword();
      if (requiredFields) {
        (Object.values(this.password).every((x) => x === this.password.currentPassword)) &&
        this.passwordErrors.push(ValidationMessages.repeatOldPassword);
        (this.password.confirmPassword !== this.password.newPassword) &&
        this.passwordErrors.push(ValidationMessages.accountPasswordNotMatch);
        const error = validatePassword(this.password.confirmPassword,
          this.user.email,
          this.user.firstName,
          this.user.lastName);
        (error.length) &&
          this.passwordErrors.push(ValidationMessages.passwordValidation);
      }
      return requiredFields && !this.passwordErrors.length;
    }
  }
});
